import { supabase } from "@/lib/supabase";

// =============================================================================
// Double authentification TOTP (etape A1)
// -----------------------------------------------------------------------------
// `resolveMfaRoute` decide, apres connexion, si la session peut acceder aux
// routes metier :
//   - aal2                    : acces normal ;
//   - aal1 + facteur verifie  : challenge TOTP (2FA facultative deja activee
//                               ou obligatoire) ;
//   - aal1 + aucun facteur    : enrolement si la population l'exige,
//                               sinon acces normal.
// L'application cote serveur est assuree par les fonctions SQL (has_role,
// has_access_*, session_mfa_ok) : ce garde ne fait qu'orienter l'ecran.
// =============================================================================

export type MfaRoute = "none" | "challenge" | "enroll";

export function resolveMfaRoute(input: {
  aal: string;
  hasVerifiedFactor: boolean;
  required: boolean;
}): MfaRoute {
  if (input.aal === "aal2") return "none";
  if (input.hasVerifiedFactor) return "challenge";
  return input.required ? "enroll" : "none";
}

export interface MfaState {
  aal: string;
  hasVerifiedFactor: boolean;
  required: boolean;
  route: MfaRoute;
}

export async function getMfaState(): Promise<MfaState> {
  const [{ data: aalData }, { data: factors }, { data: policy }] = await Promise.all([
    supabase.auth.mfa.getAuthenticatorAssuranceLevel(),
    supabase.auth.mfa.listFactors(),
    supabase.rpc("mfa_policy"),
  ]);
  const aal = aalData?.currentLevel ?? "aal1";
  const hasVerifiedFactor = (factors?.totp ?? []).some((f) => f.status === "verified");
  const required = Boolean((policy as { required?: boolean } | null)?.required);
  return {
    aal,
    hasVerifiedFactor,
    required,
    route: resolveMfaRoute({ aal, hasVerifiedFactor, required }),
  };
}
